export default __webpack_public_path__ + "static/media/OneBank.7c688ce0.svg";